import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const Crumb = styled.div<{ isLast: boolean }>`
  align-items: center;
  display: flex;
  position: relative;
  margin-left: 20px;
  height: 25px;

  &::before {
    background-color: ${(props) =>
      props.isLast ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.7)'};
    border-radius: 15px;
    content: ' ';
    left: -20px;
    height: 10px;
    position: absolute;
    width: 10px;
  }

  ${(props) =>
    !props.isLast &&
    `
    &::after {
      background-color: rgba(255, 255, 255, 0.3);
      content: ' ';
      position: absolute;
      left: -16px;
      top: 18px;
      width: 2px;
      height: 15px;
    }
  `}
`;
